import { gql, useMutation } from '@apollo/client';

const NOTIFY_SPECIAL_CASE = gql`
  mutation NotifySpecialCase($type: String!, $token: String) {
    notifySpecialCase(type: $type, token: $token)
  }
`;

export interface NotifySpecialCaseInput {
  type: 'dsfa_finished' | 'external_questionnaire_finished';
  token?: string;
}

export interface NotifySpecialCaseResult {
  notifySpecialCase: boolean;
}

export function useUserNotifySpecialCaseMutation() {
  return useMutation<NotifySpecialCaseResult, NotifySpecialCaseInput>(NOTIFY_SPECIAL_CASE);
}
